import Vue from 'vue'
//import Cookie from 'vue-cookie'
//Vue.use(Cookie)

export default {
    changeUser(context, payload){
        context.commit('SET_USER', payload)
    },
    changeAuth(context, payload){
        context.commit('SET_AUTH', payload)
    },
    changeStatus(context, payload){
        context.commit('SET_STATUS', payload)
    },
    changeCarrinho(context, payload){
      context.commit('SET_CARRINHO', payload)
    },
    addCarrinho(context, payload){
      context.commit('ADD_CARRINHO', payload)
    },
    removeFromCarrinho(context, index){
      context.commit('REMOVE_CARRINHO', index)
    },
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js